<ng-container *ngIf="!finished; else finishedTemplate">
    <div [@simpleFadeAnimation]="questionIndex"
         [@.disabled]="finished">
        <adapt-survey-question-container [question]="survey.questions[questionIndex]"
                                         [survey]="survey"></adapt-survey-question-container>
    </div>

    <div class="mt-4">
        <button *ngIf="!isFirstQuestion"
                class="btn-clementine btn-hollow me-3"
                (click)="handlePrevButton()">
            <span><i class="fa fa-arrow-left"></i> Back</span>
        </button>
        <button class="btn-clementine"
                (click)="handleContinueButton()">
            <span>{{buttonText}} <i class="fa fa-arrow-right"></i></span>
        </button>
    </div>
</ng-container>

<ng-template #finishedTemplate>
    <h2 class="py-5"><i aria-hidden="true"
           class="fal fa-spinner fa-spin"></i>&nbsp;Thank you! We're analysing your responses...</h2>
</ng-template>

<!-- DEBUG -->
<!-- <div class="mt-4 alert">
    <div>Primary Current State: {{primaryCurrentState}}</div>
    <div>Secondary Current State: {{secondaryCurrentState}}</div>
    <div>Primary Future State: {{primaryFutureState}}</div>
    <div>Secondary Future State: {{secondaryFutureState}}</div>
    <br /><br />
    <div>RankedWants</div>
    <div *ngFor="let z of rankedWants | keyvalue">
        {{z.value}}
    </div>
</div> -->
